<template>
  <component
    :is="isMegaMenuMobile ? LazyCmsMegaMenuL3Mobile : LazyCmsMegaMenuL3Desktop"
    v-bind="{ content }"
    @click="handleClick"
  />
</template>

<script lang="ts" setup>
import type { MenuItem } from '#types/components/cms/mega-menu'
import { LazyCmsMegaMenuL3Desktop, LazyCmsMegaMenuL3Mobile } from '#components'
import { MegaMenuL1ContextKey, MegaMenuL2ContextKey, MegaMenuMobileContextKey } from '#content/contexts/megamenu'

const props = defineProps<{ content: MenuItem }>()

const { $gtm } = useNuxtApp()
const isMegaMenuMobile = inject(MegaMenuMobileContextKey, false)
const l1 = inject(MegaMenuL1ContextKey)
const l2 = inject(MegaMenuL2ContextKey)

const eventLabel = props.content.delocalizedTracking || props.content.name

const handleClick = () => $gtm.push('topNav.onClickTopNavLink', `${l1} | ${l2?.title} | ${eventLabel}`)
</script>
